import React from "react";
import LoginForm from "../../components/loginLayer/LoginForm";
import Button from "../../components/loginLayer/Button";
import Header from "../../components/loginLayer/Header";
import LoginWrapper from "../../components/loginLayer/LoginWrapper";
import Message from "../../components/loginLayer/Message";
import Wrapper from "../../components/loginLayer/Wrapper";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { close, open } from "../../redux/loginLayerSlice";
import CertifyForm from "../../components/loginLayer/CertifyForm";
import PasswordForm from "../../components/loginLayer/PasswordForm";

const Login: React.FC = () => {
    const dispatch = useAppDispatch();
    const type = useAppSelector(state => state.loginLayer.type);
    const handleEvent = (task: string) => {
        if ("close" === task) {
            dispatch(close());
        }
    }

    const handleLayerPresent = () => {
        if ("login" === type) {
            return (
                <>
                    <Header>로그인</Header>
                    <LoginWrapper>
                        <Message>처음 방문하셨거나 비밀번호가 기억나지 않으신 고객님께서는<br />아래 [비밀번호 설정하기]를 통해 비밀번호를 새로 설정해주시기 바랍니다. </Message>
                        <LoginForm />
                        <a href="#" onClick={loadCertify}><strong>비밀번호 설정하기</strong> (첫방문, 비밀번호 분실 및 재설정)</a>
                    </LoginWrapper>
                    <Button className="close" handleEvent={() => handleEvent("close")}>창 닫기</Button>
                </>
            )
        } else if ("certify" === type) {
            return (
                    <>
                        <Header>고객확인</Header>
                        <LoginWrapper>
                            <Message>비밀번호 설정을 위한 보험 가입 고객님의 정보를 확인합니다.</Message>
                            <CertifyForm />
                        </LoginWrapper>
                        <Button className="close" handleEvent={() => handleEvent("close")}>창 닫기</Button>
                    </>
                )
        } else if ("password" === type) {
            return (
                <>
                    <Header>비밀번호 설정</Header>
                    <LoginWrapper>
                        <Message>사용하실 비밀번호를 설정해주세요. <br/> (영문, 숫자, 특수문자 포함 / 세 가지 조합 8자리 이상, 12자리 이하로 설정해주세요.)</Message>
                        <PasswordForm />
                    </LoginWrapper>
                    <Button className="close" handleEvent={() => handleEvent("close")}>창 닫기</Button>
                </>
            )
        }
    }

    const loadCertify = () => {
        dispatch(open("certify"))
    }
    return (
        <Wrapper>
            {
                handleLayerPresent()
            }
        </Wrapper>
    )
}

export default Login;